import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import InfoBlock from './InfoBlock'
import InfoPhoto from './InfoPhoto'
import map from 'lodash/map'
import { createUseStyles } from 'react-jss'
import { fetchOrderRequested } from '../../../store/order/action'
import { fetchFooterRequested } from '../../../store/footer/action'

const useStyles = createUseStyles({
  footerText: {
    fontWeight: '800',
    fontSize: '16px',
    alignItems: 'flex-end',
    textAlign: 'center'
  },
  titleOrder: {
    fontWeight: '800',
    fontSize: '18px',
    // lineHeight: '146%',
    alignItems: 'flex-end',
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: '9px',
    margin: 0,
  },
  whiteBlock: {
    margin: 0,
    padding: 0
  },
  info: {
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000',
    paddingBottom: '29px',
    margin: 0,
  }
})

const ConfirmOrder = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { order, loading } = useSelector(state => state.order)
  const hash = props.match.params.hash
  const responseImages = arrayPhotos =>
    map(arrayPhotos, (image, _key) => {
      const {
        original_url: src,
        thumb_url: thumbnail,
      } = image
      return {
        src,
        thumbnail,
        thumbnailWidth: 70,
        caption: '',
        thumbnailHeight: 70,
      }
    })

  useEffect(() => {
    dispatch(fetchOrderRequested({ hash }))
  }, [])

  useEffect(() => {
    if (!loading) {
      dispatch(fetchFooterRequested({ pid: 'sarafanlinks_share_order', c: order.id }))
    }
  }, [loading])

  if (order.error) {
    return (<div>
      <p className={'text-center'}>Информация о заказе не найдена :-(</p>
      <button className={'btn btn-lg btn-primary btn-block'} onClick={this.handleRefetch}>Попробовать еще раз</button>
    </div>)
  }
  if (loading) {
    return (<div>
      <p className={'text-center'}>Информация о заказе загружается</p>
    </div>)
  }

  return (
    <div className={classes.whiteBlock}>
      <Row>
        <Col md={12} lg={12} xl={12} sm={12} xs={12} className={classes.whiteBlock}>
          <p className={classes.titleOrder}>Заявка</p>
        </Col>
        <Col md={12} lg={12} xl={12} sm={12} xs={12} className={classes.whiteBlock}>
          <p className={classes.info}>{order.skill.name}</p>
        </Col>
        <Col md={12} lg={12} xl={12} sm={12} xs={12}
             className={classes.whiteBlock}
             style={{
               lineHeight: '8px',
               width: '100%'
             }}
        >
          <p className="mb-3 text-center font-weight-normal"
             style={{
               marginRight: '15px',
               marginLeft: '15px',
               marginTop: '10px',
               marginBottom: '20px',
               height: '33px',
               borderBottom: '4px solid #4681F5',
             }}
          ><b>Детали </b></p>
        </Col>
      </Row>
      <InfoBlock label={'Описание'} value={order.description}/>
      <InfoBlock label={'Место оказания услуги'} value={order.city.name}/>
      <InfoBlock label={'Бюджет'} value={order.budget || 'Договорной'}/>
      <InfoBlock label={'Дата'} value={order.due_datetime}  date={true}/>
      <InfoPhoto label={'Фото'} photos={responseImages(order.photos)}/>
      <Row className={classes.footerText}>
        <Col md={12}>
          <p className={'text-center'}>Чтобы связаться с заказчиком,<br/> скачайте приложение</p>
        </Col>
      </Row>
    </div>
  )
}

export default ConfirmOrder



// WEBPACK FOOTER //
// ./src/App/component/ConfirmOrder/index.jsx